import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

import {Right} from "@nutui/icons-vue";
import {defaultHeaderImg} from "@/lib/util";

export default /*@__PURE__*/_defineComponent({
  __name: 'FragmentFullGroups',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_nut_avatar = _resolveComponent("nut-avatar")!
  const _component_nut_avatar_group = _resolveComponent("nut-avatar-group")!
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createBlock(_component_a_flex, {
    class: "full-group-list",
    justify: "space-between",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, {
        vertical: "",
        class: "list"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_flex, {
            class: "item",
            gap: "small",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_nut_avatar_group, { size: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_3)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[0] || (_cache[0] = _createElementVNode("text", null, "恭喜 张三、李四... 满团啦！", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            class: "item",
            gap: "small",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_nut_avatar_group, { size: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createElementVNode("text", null, "恭喜 张三、李四... 满团啦！", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            class: "item",
            gap: "small",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_nut_avatar_group, { size: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_8)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_nut_avatar, { size: "23" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(defaultHeaderImg),
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("text", null, "恭喜 张三、李四... 满团啦！", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_flex, {
        align: "center",
        class: "more"
      }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createTextVNode("查看满团榜 ", -1)),
          _createVNode(_unref(Right))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})